import templateUrl from './stock.view.html'

/**
 * Stock detail Report route
 *
 * @namespace routes.ReportStockView
 * @type {TmrRoute}
 */

/**
 * Example of custom View
 * In this case we need to set
 * params: {
 *     url
 *  }
 * resolve: {
 *    resource: query to get single resource
 *  }
 */
export const route = {
  name: 'report.stock.view',
  label: 'REPORT.STOCK.VIEW.TITLE',
  component: 'tmrReportStockView',
  accessControl: ['Resource.view', 'Resource.Stock.view'],
  abstract: false,
  url: '/stock/details?:upc:zoneId',
  paging: true,
  params: {
    orderBy: 'UPC',
    upc: null,
    zoneId: null,
  },
  resolve: {
    resource: /*@ngInject*/ ($transition$, Stock) =>
      Stock.query({
        upc: $transition$.params().upc,
        'zone.id': $transition$.params().zoneId,
        limit: 1,
      }).$promise.then(res => res[0]),
    items: /*@ngInject*/ ($transition$, Item, TmrPaging, resource) =>
      Item.pagedQuery(
        TmrPaging.resolveParams($transition$, {
          upc: resource.upc,
          'zone.id': resource.zone.id,
        })
      ),
    itemsCount: /*@ngInject*/ (Item, resource) =>
      Item.count({ upc: resource.upc, 'zone.id': resource.zone.id }),
  },
}

/**
 * Component for {@link routes.tmrReportStockView Stock Report route}
 *
 * @type {ngComponent}
 */
export const tmrReportStockView = {
  ngType: 'component',
  templateUrl,
  bindings: {
    resource: '<',
    items: '<',
    itemsCount: '<',
    currentPage: '<',
    pageSize: '<',
  },
}
